(ns app.front.view.common.applications-section
  (:require [app.domain.verdict.model :as verdict-model]
            [app.domain.workspace.model :as workspace-model]
            [app.front.ui.section :as section]
            [app.front.ui.table :as ui-table]
            [app.front.view.workspace.util :as ws-util]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub]]))


(defn- workspace-id-col [workspace]
  [:div.flex.flex-col.pr-4
   [:span
    (or (:workspace/municipal-case-id workspace)
        (:workspace/id workspace))]])


(defn- expiration-col [format-date workspace]
  (let [app     (workspace-model/workspace-application workspace)
        verdict (verdict-model/non-draft-verdict app)
        section (verdict-model/find-section verdict {:verdict.section/id :valid-until-date})]
    (format-date (:verdict.section/content section))))


(defn- state-and-update-col [tr workspace]
  [:div.flex.flex-col
   [:span.uppercase.mb-2 (ws-util/workspace-state
                           tr
                           {:workspace-state (:domain/state workspace)
                            :phase-state     (-> workspace
                                                 workspace-model/workspace-target
                                                 :domain/state)})]])

(defn applications [tr workspaces]
  (let [format-date        (<sub [::date-util/date-fn])
        ordered-workspaces (->> workspaces
                                (remove nil?)
                                (sort-by :entity/created)
                                reverse)]
    [section/section
     :applications
     {:tr tr}
     (tr [:licence/applications])
     [ui-table/modern-responsive-table
      {:items ordered-workspaces
       :tr    tr
       :link  {:description ws-util/workspace-link-description
               :make-href   ws-util/workspace-or-resume-application-href}
       :cols  [[:workspace/municipal-case-id-licence
                workspace-id-col
                {}]
               [:licence/expiration
                #(expiration-col format-date %)
                {}]
               [:applications/status
                (partial state-and-update-col tr)
                {}]]}]]))
